import * as z from "zod";

export const CookieConsentProviderSchema = z.enum(["SHOPIFY", "BLOTOUT", "ONETRUST", "CUSTOM", "PANDECTES"]);
export type CookieConsentProvider = z.infer<typeof CookieConsentProviderSchema>;

export const BlotoutConsentPreferencesSchema = z.object({
  necessary: z.boolean(),
  functional: z.boolean(),
  analytics: z.boolean(),
  marketing: z.boolean(),
  performance: z.boolean(),
});
export type BlotoutConsentPreferences = z.infer<typeof BlotoutConsentPreferencesSchema>;
